import { render } from "./ParticipantsList.vue?vue&type=template&id=1789dcc3&scoped=true"
import script from "./ParticipantsList.vue?vue&type=script&lang=js"
export * from "./ParticipantsList.vue?vue&type=script&lang=js"

import "./ParticipantsList.vue?vue&type=style&index=0&id=1789dcc3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1789dcc3"]])

export default __exports__